import { useState } from 'react';

import SvgIcon from '@lcsc-ui/components/SvgIcon';
import { Image } from 'antd';
import styled from 'styled-components';
import { Pagination, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const StyledSwiper = styled(Swiper)`
  .swiper-button-prev {
    left: 0;
    padding-right: 8px;
    width: 34px;
    height: 39px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 0 22px 22px 0;
  }
  .swiper-button-prev::after {
    font-size: 12px;
    color: #696969;
  }
  .swiper-button-next {
    right: 0;
    padding-left: 8px;
    width: 34px;
    height: 39px;
    background: rgba(0, 0, 0, 0.08);
    border-radius: 22px 0 0 22px;
  }
  .swiper-button-next::after {
    font-size: 12px;
    color: #696969;
  }
`;

const StyledPagination = styled.div`
  margin-top: 10px;
  text-align: center;
  .swiper-pagination-bullet {
    transition: all 0.3s;
    margin: 0 2px !important;
    width: 6px;
    height: 6px;
    background: #e5e5e5;
    opacity: 1;
  }
  .swiper-pagination-bullet-active {
    width: 16px;
    height: 6px;
    background: #1fa0e8;
    border-radius: 3px;
  }
`;

const ImageSwiper = ({ images, brandName, productModel }) => {
  const [visible, setVisible] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <>
      {images.length ? (
        <div className="w-[573px] h-[355px] rounded-[10px] border border-solid border-[#F1F1F1]">
          <StyledSwiper
            className="w-full h-full"
            modules={[Pagination, Navigation]}
            spaceBetween={20}
            slidesPerView={1}
            pagination={{
              clickable: true,
              el: '#pagination-custom',
            }}
            navigation
            loop
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
          >
            {images.map((image) => (
              <SwiperSlide className="!flex items-center justify-center" key={image.key}>
                <Image
                  className="w-[550px] h-[250px]"
                  src={image.url}
                  alt={`${brandName}的${productModel}系统框图`}
                  width="550"
                  height="250"
                  preview={{ mask: '点击预览', visible: false }}
                  onClick={() => setVisible(true)}
                />
              </SwiperSlide>
            ))}
          </StyledSwiper>
          <StyledPagination id="pagination-custom"></StyledPagination>
        </div>
      ) : (
        <div className="w-[573px] h-[355px] rounded-[10px] border border-solid border-[#F1F1F1] bg-[#F6F8FA] flex flex-col items-center justify-center">
          <SvgIcon app="selection" iconName="image" className="w-[76px] h-[62px]" />
          <div className="mt-[8px] text-[16px] text-[#999]">暂无数据</div>
        </div>
      )}
      <div className="hidden">
        <Image.PreviewGroup preview={{ visible, current: activeIndex, onVisibleChange: (vis) => setVisible(vis) }}>
          {images.map((image, index) => (
            <Image key={index} src={image.originUrl} alt={`${brandName}的${productModel}系统框图`} />
          ))}
        </Image.PreviewGroup>
      </div>
    </>
  );
};

export default ImageSwiper;
